// ── Worker-search helpers (page-agnostic) ───────────────────────────────────
// Declared at file top level (outside the /user|/admin gate below) so they are
// global on every page that shows a worker picker — report, tasks, devices, etc.
// The /api/worker/fetch endpoint returns field workers only (enforced server-side),
// so none of these pass a role filter.

function searchUser(query, html = false) {
    const q = query.trim();
    if (q.length < 3) {
        Toast.show("Please enter at least 3 characters", "error", 3000);
        return $.Deferred().reject().promise();
    }
    if (q.length > 30) {
        Toast.show("Please enter less than 30 characters", "error", 3000);
        return $.Deferred().reject().promise();
    }

    const atCount = (q.match(/@/g) || []).length;
    const hasAt = atCount > 0;
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q);

    if (atCount > 1 || (hasAt && !validEmail)) {
        Toast.show("Please enter a valid email address", "error", 3000);
        return $.Deferred().reject().promise();
    }

    const data = hasAt ? { email: q } : { username: q };

    return $.ajax({
        url: '/api/worker/fetch',
        method: 'GET',
        data: { ...data, html: html },
    }).fail(function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.error) {
            Toast.show(xhr.responseJSON.error, "error", 3000);
        } else {
            Toast.show("Failed to search users", "error", 3000);
        }
    });
}

/**
 * Paginated worker search — backs the unified worker-search dropdowns.
 * @param {Object} opts - { limit, offset, query (optional) }
 * @returns jQuery Deferred (ajax promise)
 */
function searchUserPaginated(opts) {
    const params = { limit: opts.limit || 15, offset: opts.offset || 0 };
    if (opts.query) params.username = opts.query;
    return $.ajax({ url: '/api/worker/fetch', method: 'GET', data: params });
}

if (window.location.pathname.startsWith("/user")) {

// Drone tiles come from the shared EstateMap module (modules/map.js).

    function renumberUserRows() {
        $('#usersTableBody tr').each(function(i) {
            $(this).find('.row-num').first().text(i + 1);
        });
    }
    renumberUserRows();

    $('.adduser-btn').on('click', function() {
        $.ajax({
            url: '/api/user/modal/add',
            method: 'GET',
        }).done(function(response) {

                const dialog = new Dialog("Add New User", `${response.html}`, { size: "2xl" });
                dialog.setButtons([
                    {
                        name: "Cancel",
                        dismiss: true,
                    },
                    {
                        name: "Create User",
                        class: "bg-green-600 text-white hover:bg-green-700",
                        onClick: function(event) {
                            const btn = $(this);
                            const loadingBtn = new LoadingButton(btn);
                            loadingBtn.start();
                            const loginEnabled = $('#loginEnabled').is(':checked');
                            if (!validateForm(loginEnabled)) {
                                loadingBtn.stop();
                                return;
                            }
                            const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                            $.ajax({
                                url: '/api/user/create',
                                method: 'POST',
                                headers: {
                                "X-CSRFToken": csrftoken
                                },
                                data:{
                                    first_name: $('#firstName').val().trim(),
                                    last_name: $('#lastName').val().trim(),
                                    username: $('#username').val().trim(),
                                    email: $('#email').val().trim(),
                                    role: $('#role').val(),
                                    login_enabled: loginEnabled ? 'true' : 'false',
                                    password: loginEnabled ? $('#password').val() : '',
                                }
                            }).done(function(response) {
                                Toast.show("User created successfully", "success", 3000);
                                dialog.hide();
                                const table = $('#usersTableBody');
                                const newRow = `
                                    <tr class="hover:bg-slate-50">
                                        <td class="px-4 py-4 text-sm text-slate-700 row-num"></td>
                                        <td class="px-4 py-4">
                                        <div class="flex items-center gap-3">
                                            <div>
                                            <div class="font-medium text-slate-900 name">${response.user.first_name} ${response.user.last_name}</div>
                                            <div class="text-sm text-slate-500 username">${response.user.username}</div>
                                            </div>
                                        </div>
                                        </td>
                                        <td class="px-4 py-4 text-sm text-slate-700">
                                            ${response.user.emp_id ? response.user.emp_id : '-'}
                                        </td>
                                        <td class="px-4 py-4">
                                        <span class="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset capitalize bg-slate-50 text-slate-700 ring-slate-600/20 tag">
                                            ${response.user.role}
                                        </span>
                                        </td>
                                        <td class="px-4 py-4 text-sm text-slate-700">${new Date(response.user.created_at).toISOString().split('T')[0]}</td>
                                        <td class="px-4 py-4">
                                        <div class="flex items-center justify-center gap-2">
                                            <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-50 userupdate-btn cursor-pointer" title="Edit user" data-id="${response.user.id}" data-role="${response.user.role}">
                                            <i class="bi bi-pencil-fill"></i>
                                            </button>
                                            <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-red-200 text-red-500 hover:bg-red-50 userdelete-btn cursor-pointer" title="Delete user" data-id="${response.user.id}">
                                            <i class="bi bi-trash3-fill"></i>
                                            </button>
                                        </div>
                                        </td>
                                    </tr>
                                `;
                                table.prepend(newRow);
                                renumberUserRows();
                            }).fail(function(jqXHR) {
                                Toast.show(JSON.parse(jqXHR.responseText).error, "error", 3000);
                            }).always(function() {
                                loadingBtn.stop();
                            });
                        }
                    }
                ]);
                dialog.show();
            }).fail(function(jqXHR) {
            Toast.show((JSON.parse(jqXHR.responseText).error), "error", 3000);
        });
    });

    $(document).on('click', '.userupdate-btn', function() {

        const id = $(this).data('id');
        const main_btn = $(this);
        $.ajax({
            url: '/api/user/modal/update',
            method: 'GET',
            data: {
                user_id: $(this).data('id')
            }
        }).done(function(response) {
                const dialog = new Dialog("Update User", `${response.html}`, { size: "2xl" });
                dialog.setButtons([
                    {
                        name: "Cancel",
                        dismiss: true,
                    },
                    {
                        name: "Update User",
                        class: "bg-green-600 text-white hover:bg-green-700 update-user-btn",
                        onClick: function(event) {
                            const btn = $(this);
                            const loadingBtn = new LoadingButton(btn);
                            loadingBtn.start();
                            const loginEnabled = $('#loginEnabled').is(':checked');
                            if (!validateForm(loginEnabled && !!$('#password').val())) {
                                loadingBtn.stop();
                                return;
                            }
                            const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                            $.ajax({
                                url: '/api/user/update',
                                method: 'POST',
                                headers: {
                                "X-CSRFToken": csrftoken
                                },
                                data:{
                                    user_id: id,
                                    first_name: $('#firstName').val().trim(),
                                    last_name: $('#lastName').val().trim(),
                                    username: $('#username').val().trim(),
                                    email: $('#email').val().trim(),
                                    role: $('#role').val(),
                                    login_enabled: loginEnabled ? 'true' : 'false',
                                    password: loginEnabled ? $('#password').val() : '',
                                }
                            }).done(function(response) {
                                Toast.show("User updated successfully", "success", 3000);
                                const u = response.user || {};
                                main_btn.data('role', u.role);
                                const tr = main_btn.closest('tr');
                                tr.find('.name').text(`${u.first_name} ${u.last_name}`);
                                tr.find('.username').text(u.username);
                                tr.find('.tag').text(u.role);
                                dialog.hide();
                            }).fail(function(jqXHR) {
                                Toast.show(JSON.parse(jqXHR.responseText).error, "error", 3000);
                            }).always(function() {
                                loadingBtn.stop();
                            });
                        }
                    }
                ]);
                dialog.show();
                const $modal = $(dialog.modal);
                const original = {};
                $modal.find('input, select, textarea').each(function() {
                    original[this.id] = $(this).val();
                });
                function anyFieldChanged() {
                    let changed = false;
                    $modal.find('input, select, textarea').each(function() {
                        if ($(this).val() != original[this.id]) {
                            changed = true;
                            return false; // break
                        }
                    });
                    return changed;
                }
                $modal.find('input, select, textarea').on('input change', function() {
                    const btn = $modal.find('.update-user-btn');
                    if (anyFieldChanged()) {
                        
                        btn.prop('disabled', false);
                        btn.removeClass('cursor-not-allowed');
                        btn.addClass('hover:bg-green-700 cursor-pointer');
                        btn.css('opacity', 1);
                    } else {
                        btn.css('opacity', 0.5);
                        btn.removeClass('hover:bg-green-700 cursor-pointer');
                        btn.addClass('cursor-not-allowed');
                        btn.prop('disabled', true);
                    }
                }).trigger('change');
            }).fail(function(jqXHR) {
            try {
                const res = JSON.parse(jqXHR.responseText);
                Toast.show(res.error, "error", 3000);
            } catch (e) {
                Toast.show(jqXHR.responseText, "error", 3000);
            }
        });
    });

    $(document).on('click', '.userdelete-btn', function() {

        const id = $(this).data('id');
        const main_btn = $(this);
        const dialog = new Dialog("Confirm Deletion", "Are you sure you want to delete this user? This action cannot be undone.", { size: "md" });
        dialog.setButtons([
            {
                name: "Cancel",
                dismiss: true,
            },
            {
                name: "Delete",
                class: "bg-red-500 text-white hover:bg-red-700",
                onClick: function(event) {
                    const btn = $(this);
                    const loadingBtn = new LoadingButton(btn);
                    loadingBtn.start();
                    const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                    $.ajax({
                        url: '/api/user/delete',
                        method: 'POST',
                        headers: {
                        "X-CSRFToken": csrftoken
                        },
                        data:{
                            user_id: id
                        }
                    }).done(function(response) {
                        Toast.show("User deleted successfully", "success", 3000);
                        main_btn.closest('tr').remove();
                        renumberUserRows();
                        dialog.hide();
                    }).fail(function(jqXHR) {
                        Toast.show(JSON.parse(jqXHR.responseText).error, "error", 3000);
                    }).always(function() {
                        loadingBtn.stop();
                    });
                }
            }
        ]);
        dialog.show();
    });


        

    function validateForm(pass=true) {
        let isValid = true;
        if (!$('#firstName').val().trim()) {
            Toast.show("First name is required", "error", 3000);
            isValid = false;
        }
        // last_name is optional now (worker records may not include it)
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (pass || $('#email').val().trim()) {
            if (!emailPattern.test($('#email').val().trim())) {
                Toast.show("Please enter a valid email address", "error", 3000);
                isValid = false;
            }
        }
        if (pass) {
            const password = $('#password').val();
            const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
            if (!passwordPattern.test(password)) {
                Toast.show("Password does not meet requirements", "error", 3000);
                isValid = false;
            }
        }
        if (!$('#role').val()) {
            Toast.show("Please select a role", "error", 3000);
            isValid = false;
        }

        return isValid;
    }

    // login-enabled toggle: show/hide the password block. Works for both add/update modals.
    $(document).on('change', '#loginEnabled', function() {
        if ($(this).is(':checked')) {
            $('#passwordBlock').removeClass('hidden');
            $('#emailBlock').removeClass('hidden');
            $('#resetPasswordTrigger').addClass('hidden');
        } else {
            $('#passwordBlock').addClass('hidden');
            $('#emailBlock').addClass('hidden');
            $('#resetPasswordTrigger').addClass('hidden');
            $('#password').val('');
            $('#email').val('');
        }
    });

    // Reset-password trigger (update modal, login already enabled).
    $(document).on('click', '#resetPasswordBtn', function() {
        $('#resetPasswordTrigger').addClass('hidden');
        $('#passwordBlock').removeClass('hidden');
        $('#password').focus();
    });

    $(document).on('input', '#password', function() {
        const password = $(this).val();
        checkPasswordStrength(password);
    });

    // Password strength checker
    function checkPasswordStrength(pwd) {
        let score = 0;
        const bars = passwordStrength.querySelectorAll('div');

        // Reset bars
        bars.forEach(bar => {
            bar.className = 'h-1 w-6 bg-slate-200 rounded';
        });

        if (pwd.length === 0) {
            strengthText.textContent = '';
            strengthText.className = 'text-slate-400';
            return;
        }

        // Length check
        if (pwd.length >= 8) score++;
        // Uppercase check
        if (/[A-Z]/.test(pwd)) score++;
        // Lowercase check
        if (/[a-z]/.test(pwd)) score++;
        // Number check
        if (/\d/.test(pwd)) score++;
        // Special character check
        if (/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) score++;

        const strength = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];
        const colors = ['bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-blue-500', 'bg-green-500'];
        const textColors = ['text-red-600', 'text-orange-600', 'text-yellow-600', 'text-blue-600', 'text-green-600'];

        for (let i = 0; i < Math.min(score, 4); i++) {
            bars[i].className = `h-1 w-6 rounded ${colors[Math.min(score - 1, 4)]}`;
        }

        strengthText.textContent = strength[Math.min(score - 1, 4)] || 'Very Weak';
        strengthText.className = textColors[Math.min(score - 1, 4)] || 'text-red-600';
    }

    $(document).on('click', '.userdata-btn', function() {

    const id = $(this).data('id');
    $.ajax({
        url: '/api/task/user',
        method: 'GET',
        data: {
            user_id: id
        }
    }).done(function(response) {
            const drawer  = new Drawer("User Productivity Data", `${response.html}`, {
            width: 'lg:max-w-7xl md:max-w-3xl w-auto',
        });
            drawer.show();
            const parsedTasks = response.tasks.map(task => ({
                ...task,
                entry_data: task.entry_data ? JSON.parse(task.entry_data) : null
            }));
            updateTaskData(parsedTasks);
            initializeMap(response.messages);
        }).fail(function(jqXHR) {
        try {
            const res = JSON.parse(jqXHR.responseText);
            Toast.show(res.error, "error", 3000);
        } catch (e) {
            Toast.show(jqXHR.responseText, "error", 3000);
        }
    });
    });

    
};
    let workermap;
    let heatmapLayer;
    let markersLayer;
    let pathLayer;
    let overlayLayer;
    let tileLayerRef;
    let currentView = 'heatmap';
    $(document).on('click', '.from-to-btn', function() {
        const fromDate = $('.from-date').val();
        const toDate = $('.to-date').val();
        const userId = $(this).data('user-id');
        const btn = $(this);
        const loadingBtn = new LoadingButton(btn);
        loadingBtn.start();
        const fromDateUTC = fromDate ? new Date(fromDate).toISOString() : null;
        const toDateUTC = toDate ? new Date(toDate).toISOString() : null;
        if (fromDateUTC && toDateUTC && fromDateUTC > toDateUTC) {
            Toast.show("From Date cannot be later than To Date", "error", 3000);
            loadingBtn.stop();
            return;
        }

        $.ajax({
            url: '/api/task/user',
            method: 'GET',
            data: {
                user_id: userId,
                from_date: fromDateUTC,
                to_date: toDateUTC
            }
        }).done(function(response) {
            $('.task-table-body').html(response.html);
            loadingBtn.stop();
            const parsedTasks = response.tasks.map(task => ({
                ...task,
                entry_data: task.entry_data ? JSON.parse(task.entry_data) : null
            }));
            updateTaskData(parsedTasks);
            initializeMap(response.messages);
        }).fail(function(jqXHR) {
            try {
                const res = JSON.parse(jqXHR.responseText);
                Toast.show(res.error, "error", 3000);
            } catch (e) {
                Toast.show(e, "error", 3000);
            }
            loadingBtn.stop();
        });
    });

    $(document).on('click', '#heatmapBtn', function() {
        showHeatmap();
    });

    $(document).on('click', '#pathBtn', function() {
        showPath();
    });

    function parseDeviceData(data) {
        const parsedData = [];
        const validPoints = [];
        
        data.forEach((message, index) => {
            try {
                const payload = JSON.parse(message.string_value);
                const timestamp = new Date(message.time / 1000000); // Convert nanoseconds to milliseconds
                
                const messageData = {
                    timestamp: timestamp,
                    time: message.time,
                    name: message.name,
                    protocol: message.protocol,
                    battery_level: payload.battery_level,
                    charging_status: payload.charging_status,
                    payload_type: payload.payload_type,
                    latitude: payload.latitude,
                    longitude: payload.longitude,
                    hasLocation: payload.latitude && payload.longitude
                };
                
                parsedData.push(messageData);
                
                // Only add to validPoints if it has GPS coordinates
                if (messageData.hasLocation) {
                    validPoints.push({
                        lat: parseFloat(payload.latitude),
                        lng: parseFloat(payload.longitude),
                        timestamp: timestamp,
                        intensity: 0.8 + (index * 0.1) // Vary intensity
                    });
                }
            } catch (error) {
                console.error('Error parsing message:', error, message);
            }
        });
        
        return { parsedData, validPoints };
    }

    function initializeMap(gpsData) {
        const { parsedData, validPoints } = parseDeviceData(gpsData);
        if (validPoints.length === 0) {
            if (workermap) {
                if (heatmapLayer) workermap.removeLayer(heatmapLayer);
                if (pathLayer) workermap.removeLayer(pathLayer);
                if (markersLayer) workermap.removeLayer(markersLayer);
            }
            Toast.show("No valid GPS data available to display the map.", "error", 3000);
            return;
        }

        if(workermap instanceof L.Map){
            workermap.remove();
        }
        const imageUrl = 'https://nh.ectrons.com/static/images/location/map1.png';
        const imageBounds = [
            [5.3882710000000005, 102.21009100000002],
            [5.428189000000001, 102.23435300000001]
        ];

        const centerLat = validPoints.reduce((sum, p) => sum + p.lat, 0) / validPoints.length;
        const centerLng = validPoints.reduce((sum, p) => sum + p.lng, 0) / validPoints.length;

        workermap = L.map('workerMap', {
            maxZoom: 21
        }).setView([centerLat, centerLng], 16);

        let blocksLayerRef = null;

        // Drone-ortho + satellite basemap from the shared EstateMap module.
        EstateMap.addBasemap(workermap).then(function () {
            if (blocksLayerRef) blocksLayerRef.bringToFront();
            if (typeof pathLayer !== 'undefined' && pathLayer && workermap.hasLayer(pathLayer)) pathLayer.bringToFront();
            if (typeof markersLayer !== 'undefined' && markersLayer && workermap.hasLayer(markersLayer)) markersLayer.bringToFront();
        });

        // Add blocks with names
        if (typeof blocks !== 'undefined' && blocks) {
            blocksLayerRef = L.geoJSON(blocks, {
                style: {
                    color: 'rgba(0, 0, 0, 0.47)',
                    weight: 1,
                    fillColor: 'rgba(66, 255, 69, 0.19)',
                    fillOpacity: 0.5
                },
                onEachFeature: function(feature, layer) {
                    const name = feature?.name ?? 'Unnamed';
                    layer.bindTooltip(name, {
                        permanent: true,
                        direction: 'center',
                        className: 'custom-tooltip'
                    });
                }
            }).addTo(workermap);
        }

        $('#mapLoading').remove();
        const firstData = parsedData[0];
        const battery_level = firstData ? firstData.battery_level : 'N/A';
        const charging_status = firstData ? firstData.charging_status : 'N/A';
        const lastUpdate = firstData ? new Date(firstData.timestamp) : 'N/A';
        const s = Math.floor((Date.now() - lastUpdate) / 1000);
        const m = Math.floor(s / 60), h = Math.floor(m / 60), d = Math.floor(h / 24);
        const time_ago = s < 60 ? `${s}s` : m < 60 ? `${m}m` : h < 24 ? `${h}h` : `${d}d`;

        $('#batteryLevel').text(`${battery_level}%`);
        $('#chargingStatus').text(`${charging_status}`);
        $('#lastUpdate').text(`${time_ago}`);
        if (battery_level < 5){
            $('#batteryLevel').addClass('text-red-600');
            $('.battery-icon').addClass('text-red-600');
        }
        createHeatmapLayer(validPoints);
        createMarkersLayer(validPoints);
        createPathLayer(validPoints);
        showPath();
    }

    function createHeatmapLayer(points) {
        const heatmapData = points.map(point => [
            point.lat,
            point.lng,
            point.intensity || 0.5
        ]);
        
        heatmapLayer = L.heatLayer(heatmapData, {
            radius: 30,
            blur: 20,
            maxZoom: 17,
            gradient: {
                0.2: 'blue',
                0.4: 'cyan',
                0.6: 'lime', 
                0.8: 'yellow',
                1.0: 'red'
            }
        });
    }
    
    function createPathLayer(points) {
        if (points.length < 1) return;
        
        const pathCoords = points.map(point => [point.lat, point.lng]);
        
        pathLayer = L.polyline(pathCoords, {
            color: 'blue',
            weight: 3,
            opacity: 0.8,
            dashArray: '5, 10'
        });
        
        createMarkersLayer(points);
    }
    
    function createMarkersLayer(points) {
    markersLayer = L.layerGroup();
    
    points.forEach((point, index) => {
        const isLatest = index === 0;
        const markerColor = isLatest ? 'blue' : 'red';
        
        const marker = L.circleMarker([point.lat, point.lng], {
            radius: isLatest ? 8 : 6,
            fillColor: markerColor,
            color: 'white',
            weight: 2,
            opacity: 1,
            fillOpacity: 0.8
        });
        
        marker.bindPopup(`
            <div class="text-sm">
                <strong>${isLatest ? 'Latest Position' : 'GPS Point'}</strong><br>
                <strong>Lat:</strong> ${point.lat.toFixed(6)}<br>
                <strong>Lng:</strong> ${point.lng.toFixed(6)}<br>
                <strong>Time:</strong> ${point.timestamp.toLocaleString()}<br>
            </div>
        `);
        
        markersLayer.addLayer(marker);
    });
    }

    function updateViewButtons() {
        const buttons = ['heatmapBtn', 'pathBtn'];
        buttons.forEach(btnId => {
            const btn = document.getElementById(btnId);
            if (btn) {
                btn.className = 'px-3 py-1 text-sm border border-slate-200 rounded hover:bg-slate-50';
            }
        });
        
        const activeBtn = document.getElementById(currentView + 'Btn');
        if (activeBtn) {
            activeBtn.className = 'px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded';
        }
    }

    function showHeatmap() {
        if (workermap && heatmapLayer) {
            if (pathLayer) workermap.removeLayer(pathLayer);
            if (markersLayer) workermap.removeLayer(markersLayer);
            workermap.addLayer(heatmapLayer);
            currentView = 'heatmap';
            updateViewButtons();
        }
    }

    function showPath() {
        if (workermap && pathLayer) {
            if (heatmapLayer) workermap.removeLayer(heatmapLayer);
            workermap.addLayer(pathLayer);
            if (markersLayer) {
                workermap.addLayer(markersLayer);
            }
            currentView = 'path';
            updateViewButtons();
        }
    }



    // Group toggle handlers
    $('.group-toggle-status').on('change', function() {
        const group = $(this).data('group');
        const enabled = $(this).is(':checked');
        toggleGroup(group, enabled, $(this));
    });

function toggleGroup(group, enabled, toggle) {
    
    // Update the status text
    const statusSpan = toggle.closest('.flex').find('span').last();
    const groupCard = toggle.closest('.border');
    
    if (enabled) {
        statusSpan.text('Active').removeClass('text-slate-500').addClass('text-emerald-600');
        groupCard.removeClass('opacity-75');
    } else {
        statusSpan.text('Inactive').removeClass('text-emerald-600').addClass('text-slate-500');
        groupCard.addClass('opacity-75');
    }
    
   
}